import { useCallback, useRef } from "react";

import { useAppContext } from "@/shared/hooks/useAppContext";
import { usePatchLawyerCustomizations } from "@/shared/hooks/usePatchLawyerCustomizations";

interface ActivityCustomizations {
  lawyer_activity_seen?: Record<string, string>;
  [key: string]: unknown;
}

export function useLawyerActivitySeen(estateId: number | undefined) {
  const { user } = useAppContext();

  const customizations = (user?.customizations as ActivityCustomizations | null) ?? {};
  const seenMap = customizations.lawyer_activity_seen ?? {};
  const seenAt = estateId != null ? (seenMap[String(estateId)] ?? null) : null;

  const timestampRef = useRef("");

  const mutation = usePatchLawyerCustomizations(() => {
    if (estateId == null) return {};
    return {
      lawyer_activity_seen: { ...seenMap, [String(estateId)]: timestampRef.current },
    };
  });

  const markSeen = useCallback(
    (timestamp: string) => {
      if (estateId == null) return;
      timestampRef.current = timestamp;
      mutation.mutate();
    },
    [mutation.mutate, estateId],
  );

  return {
    seenAt,
    markSeen,
  };
}
